export type RelayApprovalWhatsAppMessageInput = {
  itsId: string;
  name: string;
  mobile: string;
  eventLabel: string;
  whatsappGroupLink: string;
};

export function getRelayEventApprovalLabel(
  relayEvent?: { title?: string | null; name?: string | null } | null
): string {
  const title = relayEvent?.title?.trim();
  if (title) {
    return title;
  }

  const name = relayEvent?.name?.trim();
  if (name) {
    return name;
  }

  return "Waaz Relay";
}

/** WhatsApp approval message for relay access — paste into a chat after copying. */
export function buildRelayAccessApprovalWhatsAppMessage(
  input: RelayApprovalWhatsAppMessageInput
): string {
  const eventLabel = input.eventLabel.trim() || "Waaz Relay";
  const whatsappGroupLink = input.whatsappGroupLink.trim();

  return [
    "Salaam-e-Jameel,",
    "",
    `ITS: ${input.itsId.trim()}`,
    `Name: ${input.name.trim()}`,
    `Mobile: ${input.mobile.trim()}`,
    "",
    `The above ITS has been APPROVED for ${eventLabel}.`,
    "",
    "Note:",
    "1. Only the APPROVED ITS can view the Waaz on Mobile. All other family members should attend Waaz in Fakhri Manzil.",
    "2. ITS Login will be blocked if misuse is found.",
    "3. Join below whatsapp group for Waaz Relay Link.",
    "",
    whatsappGroupLink,
  ].join("\n");
}
